export default __webpack_public_path__ + "static/media/doctor6.eb7ac2fe.jpg";